'use client';

import { createContext, useContext, useState, useEffect } from 'react';

import { STORAGE_KEYS, getStoredString, setStoredString, removeStoredItem } from '@/lib/utils/storage';

interface TokenContextType {
  token: string | null;
  setToken: (token: string | null) => void;
}

const TokenContext = createContext<TokenContextType | undefined>(undefined);

export const TokenProvider = ({ children }: { children: React.ReactNode }) => {
  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    const storedToken = getStoredString(STORAGE_KEYS.TOKEN);
    if (storedToken) {
      setToken(storedToken);
    }
  }, []);

  useEffect(() => {
    if (token) {
      setStoredString(STORAGE_KEYS.TOKEN, token);
    } else {
      removeStoredItem(STORAGE_KEYS.TOKEN);
    }
  }, [token]);

  return <TokenContext.Provider value={{ token, setToken }}>{children}</TokenContext.Provider>;
};

export const useToken = () => {
  const context = useContext(TokenContext);
  if (context === undefined) {
    throw new Error('useToken must be used within a TokenProvider');
  }
  return context;
};
